import ReportPayslipComponent from '../components/payslip/reportPayslip'

const ReportPayslipPage = () => {
  return (
    <div>
       <ReportPayslipComponent/>
    </div>
  )
}

export default ReportPayslipPage
